import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { Link as RouterLink, useNavigate, useLocation, Navigate } from 'react-router-dom';
// material
import DomainOutlinedIcon from '@mui/icons-material/DomainOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { Tooltip, Card, Autocomplete, Divider, Typography, Modal, IconButton, FormLabel, Box, Stack, Tabs, Tab, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { startOfMonth, endOfMonth, format } from 'date-fns';

import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import Scrollbar from '../../Scrollbar';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
import ContactMasterDetailsPage from '../../../pages/SidebarMenus/MasterMenu/ContactMasterDetailsPage';

// -----------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};


const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #4e342e',
    position: 'sticky',
    '& .MuiTabs-indicator': {

    },
});

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    fontsize: '20px',
    color: '#E7000B',
    Transition: '2s',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        color: '#4e342e',

        opacity: 1,
    },
    '&.Mui-selected': {
        color: '#4e342e',

        fontWeight: theme.typography.fontWeightMedium,

    },
    '&.Mui-focusVisible': {
        backgroundColor: '#fff',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
export default function ClientInstallationComponent({ clientInstallationData, mode }) {
    const isViewMode = mode === "view";

    const Column = [
        { field: 'ContactPersonName', headerName: 'Contact Person Name', flex: 1 },
        { field: 'ContactNo', headerName: 'Contact No', flex: 0.5 },
        { field: 'Location', headerName: 'Location', flex: 1 },
        { field: 'Designation', headerName: 'Designation', flex: 0.5 },
        { field: 'Mobile', headerName: 'Mobile', flex: 0.5 },
        { field: 'Email', headerName: 'Email', flex: 1 },
        ...(!isViewMode
            ? [{
                field: 'actions',
                headerName: '',
                type: 'actions',
                width: 20,
                flex: 1,
                justifyContent: 'end',
                renderCell: (cellValues) => (
                    <IconButton
                        onClick={(event) =>
                            handleContactEdit(event, cellValues)
                        }
                    >
                        <Iconify
                            icon="ic:outline-edit"
                            width="20px"
                            height="20px"
                            color="primary.main"
                        />
                    </IconButton>
                )
            }]
            : [])
    ];
    const { enqueueSnackbar } = useSnackbar();
    const [tab, setTab] = useState(false);

    const [clientId, setClientId] = useState(clientInstallationData?.ClientId || "");

    const [selectedClient, setSelectedClient] = useState([]);
    const [project, setProject] = useState('');
    const [selectedProject, setSelectedProject] = useState([]);

    const [contactType, setContactType] = useState();
    const [contactTypeDropDown, setContactTypeDropDown] = useState([]);

    const [userId, setUserId] = useState([]);

    const [amcId, setAMCId] = useState("");
    const [amcDropDown, setAMCDropDown] = useState([]);

    const [openModalForCancel, setOpenModalCancel] = useState(false);
    const [back, setBack] = useState(false);

    const [classificationId, setClassificationId] = useState("");
    const [classificationDropDown, setClassificationDropDown] = useState([]);

    const [startDateValue, setStartDateValue] = useState(clientInstallationData?.StartDate || (startOfMonth(new Date())));
    const [endDateValue, setEndDateValue] = useState(clientInstallationData?.EndDate || endOfMonth(new Date()));
    const [isCheckedActive, setIsCheckedAcive] = useState(true);
    const [clientSiteData, setClientSiteData] = useState([]);

    // Contact Tab
    const [addNew, setAddNew] = useState(true);
    const [contactData, setContactData] = useState([]);
    const [pageSize, setPageSize] = useState(25);
    const [contactName, setContactName] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [email, setEmail] = useState("");
    const [designation, setDesignation] = useState("");
    const [mobile, setMobile] = useState("");
    const [location, setLocation] = useState("");
    const [contactEditData, setContactEditData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isContactSaving, setIsContactSaving] = useState(false);
    const [value, setValue] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const [contactId, setContactId] = useState(0);
    const [siteId, setSiteId] = useState(0);

    const message = {
        forCancel: 'Do you want to cancel ? ',
    };
    const backMessage = {
        forCancel: 'Do you want to back ? ',
    };
    const forCancelConfirm = (value) => {
        if (value) {
            navigate('/dashboard/master/clientinstallationlocations', { replace: true });
            setOpenModalCancel(false);
            setBack(false);
        }
        else {
            setOpenModalCancel(false);
            setBack(false);

        }
    };

    const handelCancelClick = () => {
        setOpenModalCancel(true);

    };
    const handelBackClick = () => {
        setBack(true);

    };

    const handleShowContactTab = () => {
        setTab(true);
    };

    const handleShowClientContactTab = () => {
        setTab(false);

    };
    // IsSite
    const handleIsActiveChange = (event) => {
        setIsCheckedAcive(event.target.checked);
    };

    // dropdown
    const navigate = useNavigate();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();



    // Contact Dropdowns

    const handelSelectedContacts = (newValue) => {
        const contactTtypeId = newValue?.Id || 0;
        setContactType(contactTtypeId)
    };
    // Amc Dropdowns
    const handelSelectedAMC = (newValue) => {
        const amc = newValue?.Id || 0;
        setAMCId(amc)
    };
    // Classification Dropdowns
    const handelSelectedClassification = (newValue) => {
        const classification = newValue?.Id || 0;
        setClassificationId(classification);

    };

    // Client
    const handleClient = (_, newValue) => {
        const id = newValue?.ContactId || 0;
        setClientId(id);
        formik.setFieldValue("ClientId", id);
    };

    // Project
    const handleProject = (newValue) => {
        setProject(newValue?.ProjectVersionId || "");
    };
    // Dates 


    const handleChangeValue = (event, newValue) => {
        setValue(newValue);
    };

    const handleStart = (newValue) => {
        setStartDateValue(format(newValue, "dd-MMM-yyyy"));
    };
    const handleEnd = (newValue) => {
        setEndDateValue(format(newValue, "dd-MMM-yyyy"));
    };

    // Contact Tab
    const handleAddContact = () => {
        setAddNew(false);
    }

    const handleAddNewClose = () => {
        setAddNew(true);
        handleResetContact()
    }
    const handleContactName = (e) => {
        setContactName(e.target.value)
    };
    const handleContactNo = (e) => {
        setContactNo(e.target.value)
    };
    const handleEmail = (e) => {
        setEmail(e.target.value)
    };
    const handleDesignation = (e) => {
        setDesignation(e.target.value)
    };
    const handleMobile = (e) => {
        setMobile(e.target.value)
    };
    const handleLocation = (e) => {
        setLocation(e.target.value)
    };
    const handleResetContact = () => {
        setContactName("");
        setContactNo("");
        setEmail("");
        setDesignation("");
        setMobile("");
        setLocation("");
        setContactEditData([]);
    };
    console.log(">>>>>>>>>>>>>>>>>>>>>>>", clientInstallationData)
    const handleContactSave = () => {
        setIsContactSaving(true);
        const payload = {
            "Id": contactEditData?.Id || 0,
            "ContactId": clientInstallationData?.ContactId || contactId,
            "SiteId": clientInstallationData?.SiteId || siteId,
            "Location": location || "",
            "ContactPersonName": contactName || "",
            "Designation": designation || "",
            "ContactNo": contactNo || "",
            "Mobile": mobile || "",
            "Email": email || ""
        }
        URLS.postContactMaster(payload)
            .then((response) => {
                if (response.status === 200) {
                    handleResetContact();
                    URLS.getContactMasterData({ ContactID: clientInstallationData?.ContactId || contactId })
                        .then((response) => {

                            setContactData(Array.isArray(response.data) ? response.data : []);
                        })
                        .catch(error => {
                            handleError(error, enqueueSnackbar);
                        });

                    enqueueSnackbar("Saved Contact Data Successfully. ", { variant: 'success' });
                    setIsContactSaving(false);

                }

            })
            .catch(error => {
                enqueueSnackbar("Contact Data Not Saved. ", { variant: 'error' });
                setIsContactSaving(false);

            });
    }

    const handleContactEdit = (event, cellValues) => {
        const row = cellValues.row;
        setContactEditData(row)
        console.log("cellValues", row);
        setAddNew(false);

        setContactName(row.ContactPersonName || "");
        setContactNo(row.ContactNo || "");
        setMobile(row.Mobile || "");
        setEmail(row.Email || "");
        setDesignation(row.Designation || "");
        setLocation(row.Location || "");
    }

    const ClientInstallationSchema = Yup.object().shape({
        Name: Yup.string()
            .min(2, 'Too Short!')
            .max(100, 'Too Long!')
            .required('Name is required'),
        NoOfLicences: Yup.string().max(100, 'Too Long!').required('Number Of Licences is required'),
        ProjectVersionId: Yup.string().required('Project Version is required'),
        ClientId: Yup.number()
            .moreThan(0, 'Client is required')
            .required('Client is required'),
        ContactTypeId: Yup.string().required('Contact Type  is required'),
        AMCTypeId: Yup.number()
            .moreThan(0, 'AMC Type is required')
            .required('AMC Type is required'),

        // Yup.string().email('Invalid email').required('Email is required'),
        // Address: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('Address is required'),
        // Country: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('Country is required'),
        // State: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('State is required'),
        // City: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('City is required'),
        // District: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('District is required'),
        // PinCode: Yup.string().min(2, 'Too Short!').max(6, 'Too Long!').required('PinCode is required'),
        // Region: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('Region is required'),
        // FirstContactBy: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('First Contact By is required'),

    });

    const installation = clientInstallationData || {};

    console.log("installation", installation)
    const formik = useFormik({
        initialValues: {
            SiteId: installation.SiteId || 0,
            ContactId: installation.ContactId || 0,
            Name: installation.Name || "",
            ERPCode: installation.ERPCode || "",

            ContactTypeId: installation.ContactTypeId || "",
            Remarks: installation.Remarks || "",
            IsSite: installation.IsSite ?? false,
            ClientId: installation.ClientId || 0,

            ProjectVersionId: installation.ProjectVersionId || "",
            StartDate: startDateValue,
            EndDate: endDateValue,
            AMCTypeId: installation.AMCTypeId || 25,

            NoOfLicences: installation.NoOfLicences,
            WebSite: installation.WebSite || "",
            Address: installation.Address || "",
            Country: installation.Country || "",

            State: installation.State || "",
            City: installation.City || "",
            District: installation.District || "",
            PinCode: installation.PinCode || "",

            Region: installation.Region || "",
            Classification: installation.Classification || "",
            FirstContactBy: installation.FirstContactBy || "",
            ExecutiveID: userId || "",
        },

        validationSchema: ClientInstallationSchema,
        onSubmit: (values, actions) => {
            setIsLoading(true);

            const payload = {
                "SiteId": values.SiteId || 0,
                "ContactId": values.ContactId || 0,
                "Name": values.Name || "",
                "ERPCode": values.ERPCode,
                "ContactTypeId": values.ContactTypeId,
                "Remarks": values.Remarks,
                "IsSite": values.IsSite === true ? 1 : 0,
                "ClientId": clientId || 0,
                "ProjectVersionId": values.ProjectVersionId || 0,
                "StartDate": startDateValue || null,
                "EndDate": endDateValue || null,
                "AMCTypeId": values.AMCTypeId || 0,
                "NoOfLicences": values.NoOfLicences || 0,
                "WebSite": values.WebSite,
                "Address": values.Address,
                "Country": values.Country,
                "State": values.State,
                "City": values.City,
                "District": values.District,
                "PinCode": values.PinCode,
                "Region": values.Region,
                "Classification": values.Classification,
                "FirstContactBy": values.FirstContactBy,
            };

            URLS.postClientInstallationLocations(payload)
                .then((response) => {
                    if (response.status === 200) {
                        console.log("response.data", response.data);
                        const { ContactId, SiteId } = response.data;

                        setContactId(ContactId);
                        setSiteId(SiteId);
                        enqueueSnackbar("Saved Data Successfully. ", { variant: 'success' });
                        setIsDisabled(true);
                        setIsLoading(false);
                        //  navigate('/dashboard/master/clientinstallationlocations', { replace: true });

                    }

                })
                .catch(error => {
                    enqueueSnackbar("Data Not Saved. ", { variant: 'error' });
                    setIsLoading(false);

                });
        }

    });

    useEffect(() => {
        URLS.getContactTypeIdDropDown()
            .then((response) => {
                setContactTypeDropDown(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                handleError(error, enqueueSnackbar);
            });

        URLS.getAMCDropDownData()
            .then((response) => {
                setAMCDropDown(response.data);

            })
            .catch(error => {
                handleError(error, enqueueSnackbar);
            });
        URLS.getClassificationDropDown()
            .then((response) => {
                setClassificationDropDown(response.data);

            })
            .catch(error => {
                handleError(error, enqueueSnackbar);
            });
        URLS.getServiceEntryProject()
            .then((response) => {

                setSelectedProject(response.data);
            })
            .catch(error => {
                handleError(error, enqueueSnackbar);
            });
        URLS.getClientMasterData()
            .then((response) => {

                setSelectedClient(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                handleError(error, enqueueSnackbar);
            });
        URLS.getContactMasterData({ ContactID: clientInstallationData?.ContactId })
            .then((response) => {

                setContactData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                handleError(error, enqueueSnackbar);
            });

        setUserId(CurrentLoggedInUser.ExecutiveId);
    }, []);

    useEffect(() => {
        if (!clientId) {
            setClientSiteData([]);
            return;
        }

        URLS.getServiceEntrySiteName({ ClientId: clientId })
            .then((response) => {
                setClientSiteData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(() => console.log("Error fetching client sites"));
    }, [clientId]);



    const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;



    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingBottom: 0,
                    borderBottom: '1px solid #E5E7EB',
                    pb: '4px'
                }}
            >
                {/* Left Section: Back Arrow + Tabs */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton onClick={handelBackClick} size="small" sx={{ ml: '10px' }}>
                        <ArrowBackIosNewIcon fontSize="small" />
                    </IconButton>

                    <Tabs
                        value={tab ? 1 : 0}
                        onChange={(e, newValue) => {
                            if (newValue === 0) handleShowClientContactTab();
                            else handleShowContactTab();
                        }}
                        sx={{ minHeight: '32px', mr: '10px' }}
                        TabIndicatorProps={{
                            style: { height: 3, backgroundColor: "#E7000B" }
                        }}
                    >
                        <Tab
                            label="Client Installation Location"
                            sx={{
                                textTransform: 'none',
                                minHeight: '32px',
                                fontSize: '14px',
                                color: tab ? '#8A8484' : '#121212',
                                fontWeight: tab ? 500 : 600,
                                '&.Mui-selected': {
                                    color: '#121212 !important',
                                    fontWeight: 600,
                                }
                            }}
                        />

                        <Tab
                            label="Contact Details"
                            sx={{
                                textTransform: 'none',
                                minHeight: '32px',
                                fontSize: '14px',
                                color: tab ? '#121212' : '#8A8484',
                                fontWeight: tab ? 600 : 500,
                                '&.Mui-selected': {
                                    color: '#121212 !important',
                                    fontWeight: 600,
                                }
                            }}
                        />
                    </Tabs>
                </Box>

            </Box>

            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit} >
                    <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        {!tab && (
                            <Card
                                sx={{
                                    p: 0,
                                    height: "384px",
                                    mt: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    borderRadius: clientId ? "0 16px 16px 0" : "0",
                                }}
                            >
                                <Box
                                    sx={{
                                        flex: 1,
                                        display: "flex",
                                        flexDirection: "row",
                                        overflow: "hidden",   // important: prevents double scroll
                                    }}
                                >

                                    <Box
                                        sx={{
                                            flex: 1,
                                            overflowY: "auto",
                                            px: 3,

                                        }}
                                    >
                                        <Stack spacing={2}>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel
                                                        sx={{
                                                            '&::after': {
                                                                content: '" *"',
                                                                color: 'red',
                                                            },
                                                        }}
                                                    >
                                                        Name
                                                    </FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('Name')}
                                                        error={Boolean(touched.Name && errors.Name)}
                                                        helperText={touched.Name && errors.Name}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel>ERP Code</FormLabel>
                                                    <TextField
                                                        fullWidth

                                                        size="small"
                                                        {...getFieldProps('ERPCode')}
                                                        error={Boolean(touched.ERPCode && errors.ERPCode)}
                                                        helperText={touched.ERPCode && errors.ERPCode}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>

                                                <FormControl size="small" fullWidth>
                                                    <FormLabel
                                                        sx={{
                                                            '&::after': {
                                                                content: '" *"',
                                                                color: 'red',
                                                            },
                                                        }}
                                                    >Contact Type</FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        value={
                                                            contactTypeDropDown.find(
                                                                item => item.Id === formik.values.ContactTypeId
                                                            ) || null
                                                        }
                                                        onChange={(_, newValue) =>
                                                            formik.setFieldValue(
                                                                "ContactTypeId",
                                                                newValue?.Id || ""
                                                            )
                                                        }
                                                        options={contactTypeDropDown}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder="Select Contact Type"
                                                                error={
                                                                    formik.touched.ContactTypeId &&
                                                                    Boolean(formik.errors.ContactTypeId)
                                                                }
                                                                helperText={
                                                                    formik.touched.ContactTypeId &&
                                                                    formik.errors.ContactTypeId
                                                                }
                                                            />
                                                        )}
                                                        disabled={isViewMode}
                                                    />

                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"

                                                >
                                                    <FormLabel
                                                        sx={{
                                                            '&::after': {
                                                                content: '" *"',
                                                                color: 'red',
                                                            },
                                                        }}
                                                    >
                                                        Client</FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        value={
                                                            selectedClient.find(
                                                                item => item.ContactId === formik.values.ClientId
                                                            ) || null
                                                        }
                                                        onChange={handleClient}
                                                        options={selectedClient}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option.ContactId === value?.ContactId
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder="Select Client"
                                                                error={
                                                                    formik.touched.ClientId &&
                                                                    Boolean(formik.errors.ClientId)
                                                                }
                                                                helperText={
                                                                    formik.touched.ClientId &&
                                                                    formik.errors.ClientId
                                                                }
                                                            />

                                                        )}
                                                        disabled={isViewMode}
                                                    />

                                                </FormControl>

                                            </Stack>

                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <FormControl fullWidth size="small">
                                                    <FormLabel sx={{
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                    >Project Version</FormLabel>

                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        options={selectedProject}
                                                        value={
                                                            selectedProject.find(
                                                                (item) => item.ProjectVersionId === formik.values.ProjectVersionId
                                                            ) || null
                                                        }
                                                        onChange={(_, newValue) => {
                                                            formik.setFieldValue(
                                                                'ProjectVersionId',
                                                                newValue?.ProjectVersionId || ''
                                                            );
                                                        }}
                                                        getOptionLabel={(option) => option.ProjectVersionName || ""}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option.ProjectVersionId === value.ProjectVersionId
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Enter Project"
                                                                error={
                                                                    formik.touched.ProjectVersionId &&
                                                                    Boolean(formik.errors.ProjectVersionId)
                                                                }
                                                                helperText={
                                                                    formik.touched.ProjectVersionId &&
                                                                    formik.errors.ProjectVersionId
                                                                }
                                                            />
                                                        )}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>

                                                <FormControl
                                                    fullWidth
                                                    size="small"

                                                >
                                                    <FormLabel sx={{
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}>Numbar Of Licences</FormLabel>

                                                    <TextField
                                                        fullWidth

                                                        size="small"
                                                        {...getFieldProps('NoOfLicences')}
                                                        error={Boolean(touched.NoOfLicences && errors.NoOfLicences)}
                                                        helperText={touched.NoOfLicences && errors.NoOfLicences}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"

                                                >
                                                    <FormLabel sx={{
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}>Start Date</FormLabel>

                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            inputFormat="dd/MMM/yyyy"
                                                            value={startDateValue}
                                                            onChange={handleStart}
                                                            renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                                                            disabled={isViewMode}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"

                                                >
                                                    <FormLabel>End Date</FormLabel>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            inputFormat="dd/MMM/yyyy"
                                                            value={endDateValue}
                                                            onChange={handleEnd}
                                                            renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                                                            disabled={isViewMode}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>

                                            </Stack>

                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>

                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel sx={{
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}>AMC Type</FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        id="amcType"
                                                        value={
                                                            amcDropDown.find(
                                                                item => item.Id === formik.values.AMCTypeId
                                                            ) || null
                                                        }
                                                        onChange={(_, newValue) => {
                                                            formik.setFieldValue(
                                                                "AMCTypeId",
                                                                newValue?.Id || ""
                                                            );
                                                        }}
                                                        options={amcDropDown}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option.Id === value?.Id
                                                        }

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Enter AMC Type"
                                                                error={
                                                                    formik.touched.AMCTypeId &&
                                                                    Boolean(formik.errors.AMCTypeId)
                                                                }
                                                                helperText={
                                                                    formik.touched.AMCTypeId &&
                                                                    formik.errors.AMCTypeId
                                                                }
                                                            />
                                                        )}
                                                        disabled={isViewMode}
                                                    />


                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel>WebSite</FormLabel>

                                                    <TextField
                                                        fullWidth
                                                        size="small"

                                                        {...getFieldProps('WebSite')}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel>Address</FormLabel>
                                                    <TextField
                                                        fullWidth

                                                        size="small"
                                                        {...getFieldProps('Address')}
                                                        error={Boolean(touched.Address && errors.Address)}
                                                        helperText={touched.Address && errors.Address}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel>Pincode</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('PinCode')}
                                                        error={Boolean(touched.PinCode && errors.PinCode)}
                                                        helperText={touched.PinCode && errors.PinCode}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>

                                            </Stack>



                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel>State</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('State')}
                                                        error={Boolean(touched.State && errors.State)}
                                                        helperText={touched.State && errors.State}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel>District</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('District')}
                                                        error={Boolean(touched.District && errors.District)}
                                                        helperText={touched.District && errors.District}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel>City</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('City')}
                                                        error={Boolean(touched.City && errors.City)}
                                                        helperText={touched.City && errors.City}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                >
                                                    <FormLabel>Country</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('Country')}
                                                        error={Boolean(touched.Country && errors.Country)}
                                                        helperText={touched.Country && errors.Country}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>

                                            </Stack>


                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <FormControl fullWidth size="small" sx={{ width: "297px" }}>
                                                    <FormLabel>Region</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('Region')}
                                                        error={Boolean(touched.Region && errors.Region)}
                                                        helperText={touched.Region && errors.Region}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>

                                                <FormControl fullWidth size="small" sx={{ width: "297px" }}>
                                                    <FormLabel>Classification</FormLabel>

                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        id="classification"
                                                        value={
                                                            classificationDropDown.find(
                                                                item => item.Id === formik.values.Classification
                                                            ) || null
                                                        }
                                                        onChange={(_, newValue) => {
                                                            formik.setFieldValue(
                                                                "Classification",
                                                                newValue?.Id || ""
                                                            );
                                                        }}
                                                        options={classificationDropDown}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) =>
                                                            option.Id === value?.Id
                                                        }

                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Enter Classification"

                                                            />
                                                        )}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>

                                                <FormControl fullWidth size="small" sx={{ width: "297px" }}>
                                                    <FormLabel>First Contact By</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('FirstContactBy')}
                                                        error={Boolean(touched.FirstContactBy && errors.FirstContactBy)}
                                                        helperText={touched.FirstContactBy && errors.FirstContactBy}
                                                        InputProps={{ readOnly: isViewMode }}
                                                        disabled={isViewMode}
                                                    />
                                                </FormControl>
                                                <Box sx={{ width: "297px" }}>
                                                    <FormGroup>
                                                        <FormControlLabel control={
                                                            <Checkbox
                                                                checked={formik.values.IsSite}
                                                                onChange={(e) =>
                                                                    formik.setFieldValue("IsSite", e.target.checked)
                                                                } disabled={isViewMode} />
                                                        } label="IsActive" />
                                                    </FormGroup>
                                                </Box>
                                            </Stack>

                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <TextField
                                                    fullWidth
                                                    label="Remarks"
                                                    size="small"
                                                    {...getFieldProps('Remarks')}
                                                    InputProps={{ readOnly: isViewMode }}
                                                    disabled={isViewMode}

                                                />



                                            </Stack>

                                        </Stack>

                                    </Box>

                                </Box>

                            </Card>
                        )}
                        {!tab && !!clientId && (
                            <Card
                                sx={{
                                    p: 0,
                                    height: "384px",
                                    mt: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "306px",
                                    mr: 2
                                }}
                            >
                                {/* Header */}
                                <Box
                                    sx={{
                                        p: 2,
                                        borderBottom: "1px solid #eee",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    <Typography variant="h5">Client Sites</Typography>
                                    <Typography variant="body2" color="#717883">
                                        {clientSiteData?.length || 0} Sites Available
                                    </Typography>
                                </Box>

                                {/* Sites list */}
                                <Box
                                    sx={{
                                        p: 1.5,
                                        overflowY: "auto",
                                        flex: 1,

                                    }}
                                >
                                    {clientSiteData?.map((site) => (
                                        <Box
                                            key={site.SiteId}
                                            sx={{
                                                mb: 1,
                                                p: 1,
                                                border: "1px solid #E5E5E5",
                                                borderRadius: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,

                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                <DomainOutlinedIcon sx={{ color: '#C2BBBB', mr: 1, width: 18, height: 18, }} />
                                                <Typography sx={{ color: '#333333', fontWeight: 400, fontSize: '12px' }}> {site.Name}</Typography>
                                            </Box>

                                        </Box>
                                    ))}
                                </Box>
                            </Card>
                        )}


                    </Box>
                    {!tab && (
                        <Box
                            sx={{
                                // borderTop: "1px solid #D1D5DB",
                                backgroundColor: "#FFFFFF",
                                p: 1,
                                px: 3,
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 2,
                            }}
                        >
                            <Button
                                onClick={handelCancelClick}
                                size="medium"
                                variant="outlined"
                                sx={{
                                    color: '#374151',
                                    backgroundColor: '#F3F4F6',
                                    border: '1px solid #D1D5DB'
                                }}
                            >
                                Cancel
                            </Button>

                            {!isViewMode && (
                                <LoadingButton
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    sx={{ color: 'white', width: '112px' }}
                                    loading={isLoading}
                                    disabled={isDisabled}
                                >
                                    Save
                                </LoadingButton>

                            )}

                        </Box>
                    )}

                    {tab && (
                        <ContactMasterDetailsPage contactData={contactData} Column={Column} pageSize={pageSize} setPageSize={setPageSize}
                            handleAddContact={handleAddContact} addNew={addNew} handleAddNewClose={handleAddNewClose}
                            contactName={contactName} contactNo={contactNo} email={email} designation={designation} mobile={mobile} location={location}
                            handleContactName={handleContactName} handleContactNo={handleContactNo} handleEmail={handleEmail} handleDesignation={handleDesignation}
                            handleMobile={handleMobile} handleLocation={handleLocation} handleResetContact={handleResetContact} handleContactSave={handleContactSave}
                            mode={mode} isContactSaving={isContactSaving}
                        />
                    )}

                    {openModalForCancel && <ModalPopUp openCloseValue={setOpenModalCancel} msg={message.forCancel} confirm={forCancelConfirm} />}
                    {back && <ModalPopUp openCloseValue={setBack} msg={backMessage.forCancel} confirm={forCancelConfirm} />}


                </Form>


            </FormikProvider>

        </>
    );
}